import { action } from 'easy-peasy';
import { IActionSetProgram } from '../types';

const setProgram: IActionSetProgram = action((state, payload) => {
  state.item = payload;
});

export default setProgram;
